<div class="content-mask-container">
  <div class="content-mask" *ngIf="loading">
    <ab-spinner></ab-spinner>
  </div>
  <div class="ab-chart mt-3">
    <ab-line-chart
      class="ab-chart__chart"
      [config]="linechartData"
    ></ab-line-chart>
  </div>
</div>
